import React, { Fragment, useState, useEffect, CSSProperties } from "react";
import Select from "react-select";

export default function TeacherQuestionTypeSelect(props: any) {
  const [items, setItems] = useState<any[]>();
  const [value, setValue] = useState<number>();

  const groupStyles = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    fontSize: 14,
  };
  const groupBadgeStyles: CSSProperties = {
    backgroundColor: "#EBECF0",
    borderRadius: "2em",
    color: "#172B4D",
    display: "inline-block",
    fontSize: 14,
    fontWeight: "normal",
    lineHeight: "1",
    minWidth: 1,
    padding: "0.16666666666667em 0.5em",
    textAlign: "center",
  };

  const mapOptions: any = (data) => {
    const options: any[] = [];

    data?.map((item) => {
      const groupItems: any[] = [];
      const group = {
        label: item.questionCategoryName,
        options: groupItems,
      };

      item?.subTypes?.map((option) => {
        groupItems.push({
          label: item.questionCategoryName + " - " + option.name,
          value: option.questionTypeId,
          data: option,
        });
      });
      options.push(group);
    });

    return options;
  };
  const formatGroupLabel = (data: any) => {
    return (
      <div style={groupStyles}>
        <span>{data.label}</span>
        <span style={groupBadgeStyles}>{data.options.length}</span>
      </div>
    );
  };

  const handleOnChange = (e) => {
    setValue(e.value);
    if (typeof props.onChange == "function") props.onChange(e);
  };

  const findItemByValue: any = () => {
    if (!value) return null;

    return items?.reduce((prev, curr) => {
      return (
        prev || curr.options.find((option) => parseInt(option.value) === value)
      );
    }, null);
  };

  useEffect(() => {
    (async () => {
      const service = await import("../../../api/question.service");
      service.getQuestionTypesForTeacher().then((resp) => {
        const options = mapOptions(resp.data);
        setItems(options);
        setValue(props.value);
      });
    })();
  }, [props.value]);

  useEffect(() => {
    const selected = findItemByValue();
    if (props.isEdit && selected) {
      props.getQuestionTypePayloadSchema(selected.data.externalCode);
    }
  }, [value]);

  return (
    <Select
      options={items}
      placeholder={""}
      onChange={handleOnChange}
      value={findItemByValue()}
      formatGroupLabel={formatGroupLabel}
      isDisabled={props.isEdit ? true : props.languages === "ES" ? true : false}
      isSearchable={true}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary25: "#B3B3B3",
          primary: "#041E42",
        },
      })}
      styles={{
        control: (base, state) => ({
          ...base,
          background:
            document.getElementsByClassName("dark")?.length > 0
              ? "#1A1C23"
              : "white",
          borderColor:
            document.getElementsByClassName("dark")?.length > 0
              ? "#6B7280"
              : "#D1D5DB",
          borderWidth: "1px",
          "&:hover": {
            borderColor:
              state.isFocused &&
              document.getElementsByClassName("dark")?.length > 0
                ? "#6b7280"
                : state.isFocused
                ? "#4c5563"
                : "",
          },
        }),
        singleValue: (base) => ({
          ...base,
          color:
            document.getElementsByClassName("dark")?.length > 0
              ? "white"
              : "#374051",
        }),
        menu: (base) => ({
          ...base,
          color:
            document.getElementsByClassName("dark")?.length > 0
              ? "#262626"
              : "#262626",
          marginTop: 0,
        }),
        input: (base) => ({
          ...base,
          color:
            document.getElementsByClassName("dark")?.length > 0 ? "white" : "",
        }),
      }}
    />
  );
}
